import * as React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { useState, useEffect } from "react";

const ImageDropZone = ({ file, onFileSelect, onFileRemove, label }) => {
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    if (!file) {
      setPreview(null);
      return;
    }
    // If the file is already a URL string (from edit mode)
    if (typeof file === "string") {
      setPreview(file);
      return;
    }
    // If the file is a File object
    const objectUrl = URL.createObjectURL(file);
    setPreview(objectUrl);

    // Free memory when component unmounts or file changes
    return () => URL.revokeObjectURL(objectUrl);
  }, [file]);

  return (
    <Box
      sx={{
        border: "2px dashed #ccc",
        borderRadius: "8px",
        padding: "16px",
        textAlign: "center",
        position: "relative",
        bgcolor: "#fafafa",
        cursor: "pointer",
        transition: "all 0.3s ease",
        height: "180px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        "&:hover": {
          borderColor: "#1976d2",
          bgcolor: "#f4f9ff",
          boxShadow: "0 4px 12px rgba(25, 118, 210, 0.1)",
        },
      }}
      component="label"
    >
      {preview ? (
        <>
          <img
            src={preview}
            alt={label}
            style={{
              maxHeight: "100%",
              maxWidth: "100%",
              objectFit: "contain",
              borderRadius: "4px"
            }}
          />
          <IconButton
            size="small"
            onClick={(e) => {
              e.preventDefault();
              onFileRemove();
            }}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              bgcolor: "rgba(255, 255, 255, 0.8)",
              "&:hover": { bgcolor: "rgba(255, 255, 255, 1)" },
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </>
      ) : (
        <>
          <CloudUploadIcon sx={{ fontSize: 40, color: "#9e9e9e", mb: 1 }} />
          <Typography variant="body2" color="text.secondary">
            Click or drag to upload {label}
          </Typography>
        </>
      )}
      <input
        type="file"
        hidden
        accept="image/*"
        onChange={(e) => {
          if (e.target.files && e.target.files[0]) {
            onFileSelect(e.target.files[0]);
          }
        }}
      />
    </Box>
  );
};

export default ImageDropZone;
